import type { FeatureNames } from "./feature-names";

/** German names of the staff features and settings categories. Same keys as features.fr.ts. */
export const featuresDe: FeatureNames = {
  features: {
    SEARCH_ACCOUNTS_STAFF_FEATURE_ENABLEMENT: "Konten suchen",
    VIEW_ACCOUNTS_STAFF_FEATURE_ENABLEMENT: "Konto ansehen",
    REVEAL_CONTACT_DETAILS_STAFF_FEATURE_ENABLEMENT: "Nummer anzeigen",
    EDIT_CUSTOMER_SETTINGS_STAFF_FEATURE_ENABLEMENT: "Einstellungen eines Kunden ändern",
    CLAIM_CASES_STAFF_FEATURE_ENABLEMENT: "Fälle übernehmen",
    REASSIGN_CASES_STAFF_FEATURE_ENABLEMENT: "Fälle neu zuweisen",
    ACT_ON_BEHALF_STAFF_FEATURE_ENABLEMENT: "Im Namen eines Kunden handeln",
    CORRECT_ACCOUNT_DETAILS_STAFF_FEATURE_ENABLEMENT: "Kontodaten korrigieren",
    REVIEW_VERIFICATIONS_STAFF_FEATURE_ENABLEMENT: "Prüfungen bearbeiten",
    VIEW_ID_IMAGES_STAFF_FEATURE_ENABLEMENT: "Ausweisbilder ansehen",
    APPROVE_PROS_STAFF_FEATURE_ENABLEMENT: "Profis freigeben",
    VIEW_PAYMENTS_STAFF_FEATURE_ENABLEMENT: "Zahlungen ansehen",
    ISSUE_REFUNDS_STAFF_FEATURE_ENABLEMENT: "Erstatten",
    ISSUE_CREDITS_STAFF_FEATURE_ENABLEMENT: "Gutschrift gewähren",
    WAIVE_FEES_STAFF_FEATURE_ENABLEMENT: "Gebühren erlassen",
    MARK_PAYMENTS_PAID_STAFF_FEATURE_ENABLEMENT: "Zahlung als bezahlt markieren",
    MANAGE_PLAN_PRICES_STAFF_FEATURE_ENABLEMENT: "Tarifpreise festlegen",
    RUN_PROMOS_STAFF_FEATURE_ENABLEMENT: "Aktionen durchführen",
    OFFER_DISCOUNTS_STAFF_FEATURE_ENABLEMENT: "Rabatte gewähren",
    MANAGE_SUBSCRIPTIONS_STAFF_FEATURE_ENABLEMENT: "Abo verlängern oder beenden",
    APPROVE_PAYMENT_REQUESTS_STAFF_FEATURE_ENABLEMENT: "Über dem Limit genehmigen",
    RECONCILE_PAYMENTS_STAFF_FEATURE_ENABLEMENT: "Zahlungen abgleichen",
    EXPORT_PAYMENTS_STAFF_FEATURE_ENABLEMENT: "Exportieren",
    HANDLE_REPORTS_STAFF_FEATURE_ENABLEMENT: "Meldungen bearbeiten",
    SET_REPORT_SEVERITY_STAFF_FEATURE_ENABLEMENT: "Schweregrad einer Meldung festlegen",
    SUSPEND_PENDING_INVESTIGATION_STAFF_FEATURE_ENABLEMENT: "Vorläufige Sperre",
    ISSUE_VERDICTS_STAFF_FEATURE_ENABLEMENT: "Entscheidung treffen",
    BAN_PERMANENTLY_STAFF_FEATURE_ENABLEMENT: "Dauerhaft sperren",
    HANDLE_APPEALS_STAFF_FEATURE_ENABLEMENT: "Einsprüche bearbeiten",
    REFER_TO_POLICE_STAFF_FEATURE_ENABLEMENT: "An die Polizei übergeben",
    SHARE_DATA_WITH_POLICE_STAFF_FEATURE_ENABLEMENT: "Daten mit der Polizei teilen",
    PLACE_LEGAL_HOLDS_STAFF_FEATURE_ENABLEMENT: "Beweise sichern",
    MODERATE_REVIEWS_STAFF_FEATURE_ENABLEMENT: "Bewertungen moderieren",
    SEND_SMS_STAFF_FEATURE_ENABLEMENT: "SMS senden",
    SEND_BULK_SMS_STAFF_FEATURE_ENABLEMENT: "Massen-SMS senden",
    EDIT_SMS_TEMPLATES_STAFF_FEATURE_ENABLEMENT: "SMS-Vorlagen bearbeiten",
    MANAGE_APP_FEATURES_STAFF_FEATURE_ENABLEMENT: "App-Funktionen verwalten",
    EDIT_RULES_STAFF_FEATURE_ENABLEMENT: "Regeln bearbeiten",
    EDIT_PRICING_STAFF_FEATURE_ENABLEMENT: "Preise bearbeiten",
    EDIT_CATEGORIES_STAFF_FEATURE_ENABLEMENT: "Berufe bearbeiten",
    INVITE_STAFF_STAFF_FEATURE_ENABLEMENT: "Ins Team einladen",
    DEACTIVATE_STAFF_STAFF_FEATURE_ENABLEMENT: "Mitglied deaktivieren",
    END_STAFF_SESSIONS_STAFF_FEATURE_ENABLEMENT: "Sitzungen beenden",
    MANAGE_TEAMS_STAFF_FEATURE_ENABLEMENT: "Teams verwalten",
    MANAGE_ROLES_STAFF_FEATURE_ENABLEMENT: "Rollen verwalten",
    MANAGE_ACTION_ENABLEMENTS_STAFF_FEATURE_ENABLEMENT: "Aktionsfreigaben verwalten",
    ASSIGN_ROLES_STAFF_FEATURE_ENABLEMENT: "Rollen zuweisen",
    MANAGE_LEADS_STAFF_FEATURE_ENABLEMENT: "Vertrieb und Wachstum",
    VIEW_MARKETPLACE_STAFF_FEATURE_ENABLEMENT: "Marktbetrieb",
    MANAGE_HUMAN_RESOURCES_STAFF_FEATURE_ENABLEMENT: "Personalwesen",
    VIEW_AUDIT_LOG_STAFF_FEATURE_ENABLEMENT: "Audit-Protokoll lesen",
    VIEW_SENSITIVE_AUDIT_VALUES_STAFF_FEATURE_ENABLEMENT: "Sensible Werte sehen",
    VIEW_HEALTH_DASHBOARD_STAFF_FEATURE_ENABLEMENT: "Übersicht ansehen",
  },
  /** The permissions that sit on those features (ADR-0019), by settingId. */
  permissions: {
    ISSUE_REFUND_STAFF_PERMISSION: "Eine Erstattung ausstellen",
    SETTLE_REFUND_STAFF_PERMISSION: "Eine Erstattung abschließen",
    ISSUE_CREDIT_STAFF_PERMISSION: "Eine Gutschrift ausstellen",
    WAIVE_FEE_STAFF_PERMISSION: "Eine Gebühr erlassen",
    REPLY_TO_CUSTOMER_STAFF_PERMISSION: "Einem Kunden antworten",
    CLOSE_CASE_STAFF_PERMISSION: "Einen Fall schließen",
  },
  /** Customer features (Fonctionnalités), by settingId. */
  customerFeatures: {
    SEARCH_PROS_USER_FEATURE_ENABLEMENT: "Profis suchen",
    NEARBY_PROS_USER_FEATURE_ENABLEMENT: "Profis in der Nähe",
    REQUEST_PRO_USER_FEATURE_ENABLEMENT: "Profi anfragen",
    POST_OPEN_JOB_USER_FEATURE_ENABLEMENT: "Offene Anfrage veröffentlichen",
    JOB_PHOTOS_USER_FEATURE_ENABLEMENT: "Fotos in einer Anfrage",
    SELECT_QUOTE_USER_FEATURE_ENABLEMENT: "Angebot auswählen",
    LEAVE_REVIEWS_USER_FEATURE_ENABLEMENT: "Bewertung abgeben",
    REQUEST_CALLBACK_USER_FEATURE_ENABLEMENT: "Rückruf anfordern",
    SAVE_FAVORITE_PROS_USER_FEATURE_ENABLEMENT: "Lieblingsprofis",
    REBOOK_PRO_USER_FEATURE_ENABLEMENT: "Profi erneut buchen",
    SHARE_PRO_PROFILE_USER_FEATURE_ENABLEMENT: "Profil eines Profis teilen",
    SCHEDULE_JOB_USER_FEATURE_ENABLEMENT: "Anfrage planen",
    URGENT_JOB_USER_FEATURE_ENABLEMENT: "Dringende Anfrage",
    BECOME_PRO_USER_FEATURE_ENABLEMENT: "Profi werden",
    LEAD_PREFERENCES_USER_FEATURE_ENABLEMENT: "Lead-Einstellungen",
    EDIT_RATES_USER_FEATURE_ENABLEMENT: "Preise bearbeiten",
    BROWSE_OPEN_JOBS_USER_FEATURE_ENABLEMENT: "Offene Anfragen durchsuchen",
    QUOTE_JOBS_USER_FEATURE_ENABLEMENT: "Angebote zu Anfragen",
    PRO_SUBSCRIPTIONS_USER_FEATURE_ENABLEMENT: "Profi-Abos",
    SUBMIT_VERIFICATION_USER_FEATURE_ENABLEMENT: "Verifizierung einreichen",
    PAUSE_LEADS_USER_FEATURE_ENABLEMENT: "Leads pausieren",
    PORTFOLIO_PHOTOS_USER_FEATURE_ENABLEMENT: "Fotos von Arbeiten",
    QUICK_REPLIES_USER_FEATURE_ENABLEMENT: "Schnellantworten",
    ACTIVITY_PAGE_USER_FEATURE_ENABLEMENT: "Aktivitätsseite",
    DECLARE_JOB_OUTCOME_USER_FEATURE_ENABLEMENT: "Ergebnis einer Anfrage melden",
    LEAD_NOTIFICATIONS_USER_FEATURE_ENABLEMENT: "Leads als Benachrichtigung",
    SMS_LEADS_USER_FEATURE_ENABLEMENT: "Leads per SMS",
    JOB_REMINDERS_USER_FEATURE_ENABLEMENT: "Erinnerungen an Anfragen",
    SWITCH_MODE_USER_FEATURE_ENABLEMENT: "Zwischen Kunde und Profi wechseln",
    MESSAGING_USER_FEATURE_ENABLEMENT: "Nachrichten senden",
    SEND_PHOTOS_USER_FEATURE_ENABLEMENT: "Fotos senden",
    SHARE_LOCATION_USER_FEATURE_ENABLEMENT: "Standort teilen",
    CHANGE_PHONE_USER_FEATURE_ENABLEMENT: "Telefonnummer ändern",
    CHANGE_EMAIL_USER_FEATURE_ENABLEMENT: "E-Mail ändern",
    CONTACT_US_USER_FEATURE_ENABLEMENT: "Kontakt aufnehmen",
    CREATE_CLIENT_PROFILE_USER_FEATURE_ENABLEMENT: "Kundenprofil erstellen",
    REPORT_USER_USER_FEATURE_ENABLEMENT: "Jemanden melden",
    BLOCK_USER_USER_FEATURE_ENABLEMENT: "Jemanden blockieren",
    APPEAL_DECISION_USER_FEATURE_ENABLEMENT: "Einspruch gegen eine Entscheidung",
    SECURITY_ACTIVITY_USER_FEATURE_ENABLEMENT: "Sicherheitsaktivität",
    REFER_FRIENDS_USER_FEATURE_ENABLEMENT: "Freunde werben",
  },
  /** Every action, so the audit log names what was done instead of its id (#185). */
  actions: {
    SIGN_UP_USER_ACTION: "Registrieren",
    SIGN_IN_USER_ACTION: "Anmelden",
    SIGN_OUT_USER_ACTION: "Abmelden",
    UPDATE_PERSONAL_INFO_USER_ACTION: "Persönliche Daten ändern",
    CHANGE_PHONE_USER_ACTION: "Telefonnummer ändern",
    CHANGE_EMAIL_USER_ACTION: "E-Mail-Adresse ändern",
    CHANGE_PASSWORD_USER_ACTION: "Passwort ändern",
    SWITCH_MODE_USER_ACTION: "Zwischen Kunde und Profi wechseln",
    CREATE_CLIENT_PROFILE_USER_ACTION: "Ein Kundenprofil erstellen",
    UPDATE_SETTING_USER_ACTION: "Eine Einstellung ändern",
    VIEW_SECURITY_ACTIVITY_USER_ACTION: "Sicherheitsaktivität ansehen",
    REFER_FRIEND_USER_ACTION: "Einen Freund werben",
    DELETE_ACCOUNT_USER_ACTION: "Das Konto löschen",
    BECOME_PRO_USER_ACTION: "Profi werden",
    SUBMIT_VERIFICATION_USER_ACTION: "Einen Ausweis zur Prüfung einreichen",
    UPDATE_PRO_PROFILE_USER_ACTION: "Das Profi-Profil ändern",
    UPDATE_RATES_USER_ACTION: "Preise ändern",
    ADD_PORTFOLIO_PHOTO_USER_ACTION: "Ein Foto einer Arbeit hinzufügen",
    REMOVE_PORTFOLIO_PHOTO_USER_ACTION: "Ein Foto einer Arbeit entfernen",
    UPDATE_LEAD_PREFERENCES_USER_ACTION: "Lead-Einstellungen ändern",
    PAUSE_LEADS_USER_ACTION: "Leads pausieren",
    RESUME_LEADS_USER_ACTION: "Leads fortsetzen",
    VIEW_OPEN_JOBS_USER_ACTION: "Offene Anfragen ansehen",
    VIEW_ACTIVITY_USER_ACTION: "Aktivität ansehen",
    REQUEST_PRO_USER_ACTION: "Einen Profi anfragen",
    POST_OPEN_JOB_USER_ACTION: "Eine offene Anfrage veröffentlichen",
    REBOOK_PRO_USER_ACTION: "Einen Profi erneut buchen",
    UPDATE_JOB_USER_ACTION: "Eine Anfrage ändern",
    ADD_JOB_PHOTOS_USER_ACTION: "Fotos zu einer Anfrage hinzufügen",
    SCHEDULE_JOB_USER_ACTION: "Eine Anfrage planen",
    MARK_JOB_URGENT_USER_ACTION: "Eine Anfrage als dringend markieren",
    SELECT_QUOTE_USER_ACTION: "Ein Angebot auswählen",
    CANCEL_JOB_USER_ACTION: "Eine Anfrage stornieren",
    SUBMIT_QUOTE_USER_ACTION: "Ein Angebot senden",
    UPDATE_QUOTE_USER_ACTION: "Ein Angebot ändern",
    WITHDRAW_QUOTE_USER_ACTION: "Ein Angebot zurückziehen",
    ACCEPT_JOB_USER_ACTION: "Eine Anfrage annehmen",
    DECLINE_JOB_USER_ACTION: "Eine Anfrage ablehnen",
    DECLARE_JOB_OUTCOME_USER_ACTION: "Melden, wie eine Anfrage endete",
    SEARCH_PROS_USER_ACTION: "Profis suchen",
    SEARCH_PROS_NEARBY_USER_ACTION: "Profis in der Nähe suchen",
    VIEW_PRO_PROFILE_USER_ACTION: "Das Profil eines Profis ansehen",
    SAVE_FAVORITE_PRO_USER_ACTION: "Einen Profi als Favorit speichern",
    REMOVE_FAVORITE_PRO_USER_ACTION: "Einen Profi aus den Favoriten entfernen",
    SHARE_PRO_PROFILE_USER_ACTION: "Das Profil eines Profis teilen",
    OPEN_CONVERSATION_USER_ACTION: "Eine Unterhaltung öffnen",
    SEND_MESSAGE_USER_ACTION: "Eine Nachricht senden",
    SEND_PHOTO_USER_ACTION: "Ein Foto senden",
    SHARE_LOCATION_USER_ACTION: "Einen Standort teilen",
    READ_MESSAGES_USER_ACTION: "Nachrichten lesen",
    SAVE_QUICK_REPLY_USER_ACTION: "Eine Schnellantwort speichern",
    LEAVE_REVIEW_USER_ACTION: "Eine Bewertung abgeben",
    SUBSCRIBE_TO_PLAN_USER_ACTION: "Einen Tarif abonnieren",
    CANCEL_SUBSCRIPTION_USER_ACTION: "Die Verlängerung kündigen",
    RESUME_SUBSCRIPTION_USER_ACTION: "Die Verlängerung fortsetzen",
    CHANGE_PLAN_USER_ACTION: "Den Tarif wechseln",
    PAY_FEE_USER_ACTION: "Eine Gebühr bezahlen",
    CONTACT_SUPPORT_USER_ACTION: "Den Support kontaktieren",
    REQUEST_CALLBACK_USER_ACTION: "Einen Rückruf anfordern",
    REPORT_USER_USER_ACTION: "Jemanden melden",
    BLOCK_USER_USER_ACTION: "Jemanden blockieren",
    UNBLOCK_USER_USER_ACTION: "Jemanden entsperren",
    APPEAL_DECISION_USER_ACTION: "Einspruch gegen eine Entscheidung einlegen",
    CREATE_EXPERIMENT_STAFF_ACTION: "Ein Experiment starten",
    MOVE_EXPERIMENT_STAFF_ACTION: "Ein Experiment ausweiten oder stoppen",
    ADD_LEAD_STAFF_ACTION: "Einen Interessenten anlegen",
    MOVE_LEAD_STAFF_ACTION: "Einen Interessenten weiterbringen",
    CREATE_CAMPAIGN_STAFF_ACTION: "Eine Kampagne entwerfen",
    SEND_CAMPAIGN_STAFF_ACTION: "Eine Kampagne senden",
    OPEN_INCIDENT_STAFF_ACTION: "Eine Störung eröffnen",
    UPDATE_INCIDENT_STAFF_ACTION: "Eine Störung aktualisieren",
    VIEW_MARKETPLACE_STAFF_ACTION: "Zustand des Markts ansehen",
    VIEW_MARKETPLACE_JOB_STAFF_ACTION: "Einen Auftrag ansehen",
    SIGN_IN_STAFF_ACTION: "An der Konsole anmelden",
    SIGN_OUT_STAFF_ACTION: "Von der Konsole abmelden",
    SET_PASSWORD_STAFF_ACTION: "Ein Konsolen-Passwort festlegen",
    UPDATE_STAFF_SETTING_STAFF_ACTION: "Eine Konsolen-Einstellung ändern",
    SEARCH_ACCOUNTS_STAFF_ACTION: "Konten suchen",
    VIEW_ACCOUNT_STAFF_ACTION: "Ein Konto ansehen",
    REVEAL_CONTACT_DETAILS_STAFF_ACTION: "Eine Telefonnummer anzeigen",
    EDIT_CUSTOMER_SETTING_STAFF_ACTION: "Eine Einstellung eines Kunden ändern",
    CORRECT_ACCOUNT_DETAILS_STAFF_ACTION: "Kontodaten korrigieren",
    CLAIM_CASE_STAFF_ACTION: "Einen Fall übernehmen",
    LOG_CALL_STAFF_ACTION: "Einen Anruf erfassen",
    REPLY_TO_CASE_STAFF_ACTION: "Einem Kunden antworten",
    ADD_CASE_NOTE_STAFF_ACTION: "Eine interne Notiz hinzufügen",
    CLOSE_CASE_STAFF_ACTION: "Einen Fall schließen",
    REASSIGN_CASE_STAFF_ACTION: "Einen Fall neu zuweisen",
    LINK_CASE_CUSTOMER_STAFF_ACTION: "Einen Kunden mit einem Fall verknüpfen",
    START_ON_BEHALF_SESSION_STAFF_ACTION: "Beginnen, im Namen eines Kunden zu handeln",
    END_ON_BEHALF_SESSION_STAFF_ACTION: "Aufhören, im Namen eines Kunden zu handeln",
    VIEW_VERIFICATION_STAFF_ACTION: "Eine Prüfung ansehen",
    APPROVE_VERIFICATION_STAFF_ACTION: "Eine Prüfung genehmigen",
    REJECT_VERIFICATION_STAFF_ACTION: "Eine Prüfung ablehnen",
    VIEW_ID_IMAGES_STAFF_ACTION: "Ausweisbilder ansehen",
    APPROVE_PRO_STAFF_ACTION: "Einen Profi freigeben",
    REJECT_PRO_STAFF_ACTION: "Einen Profi ablehnen",
    VIEW_PAYMENTS_STAFF_ACTION: "Zahlungen ansehen",
    ISSUE_REFUND_STAFF_ACTION: "Eine Erstattung ausstellen",
    ISSUE_CREDIT_STAFF_ACTION: "Eine Gutschrift ausstellen",
    WAIVE_FEE_STAFF_ACTION: "Eine Gebühr erlassen",
    MARK_PAYMENT_PAID_STAFF_ACTION: "Eine Gebühr als bezahlt markieren",
    APPROVE_PAYMENT_REQUEST_STAFF_ACTION: "Eine Anfrage genehmigen",
    REJECT_PAYMENT_REQUEST_STAFF_ACTION: "Eine Anfrage ablehnen",
    SETTLE_REFUND_STAFF_ACTION: "Eine Erstattung abschließen",
    SET_PLAN_PRICE_STAFF_ACTION: "Den Preis eines Tarifs festlegen",
    CREATE_PROMO_STAFF_ACTION: "Eine Aktion anlegen",
    END_PROMO_STAFF_ACTION: "Eine Aktion beenden",
    CREATE_DISCOUNT_STAFF_ACTION: "Einen Rabatt anlegen",
    END_DISCOUNT_STAFF_ACTION: "Einen Rabatt beenden",
    EXTEND_SUBSCRIPTION_STAFF_ACTION: "Ein Abo verlängern",
    END_SUBSCRIPTION_STAFF_ACTION: "Ein Abo beenden",
    RECONCILE_PAYMENTS_STAFF_ACTION: "Zahlungen abgleichen",
    EXPORT_PAYMENTS_STAFF_ACTION: "Zahlungen exportieren",
    OPEN_SAFETY_REPORT_STAFF_ACTION: "Eine Meldung eröffnen",
    ADD_REPORT_EVIDENCE_STAFF_ACTION: "Einer Meldung einen Beweis hinzufügen",
    SET_REPORT_SEVERITY_STAFF_ACTION: "Den Schweregrad einer Meldung festlegen",
    SUSPEND_PENDING_INVESTIGATION_STAFF_ACTION: "Ein Konto während der Prüfung sperren",
    LIFT_SUSPENSION_STAFF_ACTION: "Eine Sperre aufheben",
    ISSUE_VERDICT_STAFF_ACTION: "Ein Urteil fällen",
    BAN_PERMANENTLY_STAFF_ACTION: "Ein Konto dauerhaft sperren",
    DECIDE_APPEAL_STAFF_ACTION: "Über einen Einspruch entscheiden",
    REFER_TO_POLICE_STAFF_ACTION: "Einen Fall an die Polizei übergeben",
    SHARE_DATA_WITH_POLICE_STAFF_ACTION: "Daten mit der Polizei teilen",
    PLACE_LEGAL_HOLD_STAFF_ACTION: "Einen Legal Hold setzen",
    RELEASE_LEGAL_HOLD_STAFF_ACTION: "Einen Legal Hold aufheben",
    HIDE_REVIEW_STAFF_ACTION: "Eine Bewertung ausblenden",
    RESTORE_REVIEW_STAFF_ACTION: "Eine Bewertung wiederherstellen",
    SEND_SMS_STAFF_ACTION: "Eine SMS senden",
    SEND_BULK_SMS_STAFF_ACTION: "Eine SMS an viele Personen senden",
    EDIT_SMS_TEMPLATE_STAFF_ACTION: "Eine SMS-Vorlage bearbeiten",
    SET_USER_FEATURE_ENABLEMENT_STAFF_ACTION: "Eine Kundenfunktion ein- oder ausschalten",
    CREATE_RULE_VERSION_STAFF_ACTION: "Eine Unternehmensregel ändern",
    EDIT_PRICING_STAFF_ACTION: "Die Gebührenstufen bearbeiten",
    EDIT_CATEGORIES_STAFF_ACTION: "Die Berufe bearbeiten",
    INVITE_STAFF_STAFF_ACTION: "Ein Teammitglied einladen",
    DEACTIVATE_STAFF_STAFF_ACTION: "Ein Teammitglied deaktivieren",
    REACTIVATE_STAFF_STAFF_ACTION: "Ein Teammitglied reaktivieren",
    END_STAFF_SESSION_STAFF_ACTION: "Die Sitzungen eines Teammitglieds beenden",
    REQUEST_PERMISSION_STAFF_ACTION: "Eine Berechtigung anfragen",
    DECIDE_PERMISSION_REQUEST_STAFF_ACTION: "Auf eine Berechtigungsanfrage antworten",
    UPDATE_ACTION_ENABLEMENT_STAFF_ACTION: "Aktionsfreigabe ändern",
    REQUEST_TIME_OFF_STAFF_ACTION: "Urlaub beantragen",
    DECIDE_TIME_OFF_STAFF_ACTION: "Über einen Urlaubsantrag entscheiden",
    SET_EMPLOYMENT_STAFF_ACTION: "Beschäftigungsdaten ändern",
    OPEN_JOB_STAFF_ACTION: "Eine Stelle ausschreiben",
    EDIT_JOB_STAFF_ACTION: "Eine Stelle ändern",
    MOVE_CANDIDATE_STAFF_ACTION: "Eine Bewerbung weiterbewegen",
    OPEN_PAYROLL_STAFF_ACTION: "Einen Abrechnungsmonat öffnen",
    EDIT_PAYROLL_LINE_STAFF_ACTION: "Eine Abrechnungszeile sperren oder freigeben",
    CLOSE_PAYROLL_STAFF_ACTION: "Einen Abrechnungsmonat schließen",
    OPEN_REVIEW_CYCLE_STAFF_ACTION: "Einen Beurteilungszyklus öffnen",
    WRITE_REVIEW_STAFF_ACTION: "Eine Beurteilung schreiben",
    EDIT_COURSE_STAFF_ACTION: "Einen Kurs anlegen oder ändern",
    ENROL_IN_COURSE_STAFF_ACTION: "Sich für einen Kurs anmelden",
    CREATE_TEAM_STAFF_ACTION: "Ein Team erstellen",
    EDIT_TEAM_STAFF_ACTION: "Ein Team bearbeiten",
    SET_TEAM_MEMBERSHIP_STAFF_ACTION: "Festlegen, wer im Team ist",
    CREATE_ROLE_STAFF_ACTION: "Eine Rolle anlegen",
    EDIT_ROLE_STAFF_ACTION: "Eine Rolle bearbeiten",
    SET_STAFF_PERMISSION_STAFF_ACTION: "Eine Berechtigung erteilen oder entziehen",
    SET_STAFF_FEATURE_ENABLEMENT_STAFF_ACTION: "Eine Funktion erteilen oder entziehen",
    ASSIGN_ROLE_STAFF_ACTION: "Eine Rolle zuweisen",
    REMOVE_ROLE_STAFF_ACTION: "Eine Rolle entfernen",
    VIEW_AUDIT_LOG_STAFF_ACTION: "Das Audit-Protokoll lesen",
    VIEW_SENSITIVE_AUDIT_VALUES_STAFF_ACTION: "Sensible Audit-Werte ansehen",
    VIEW_HEALTH_DASHBOARD_STAFF_ACTION: "Das Zustands-Dashboard ansehen",
    EXPIRE_JOB_SYSTEM_ACTION: "Eine unbeantwortete Anfrage verfallen lassen",
    EXPIRE_QUOTE_SYSTEM_ACTION: "Ein Angebot verfallen lassen",
    CLOSE_OTHER_QUOTES_SYSTEM_ACTION: "Die anderen Angebote schließen",
    OPEN_CONVERSATION_ON_QUOTE_SYSTEM_ACTION: "Eine Unterhaltung zu einem Angebot öffnen",
    NOTIFY_USER_SYSTEM_ACTION: "Eine Benachrichtigung senden",
    NOTIFY_NEW_LEAD_SYSTEM_ACTION: "Einen Profi über einen neuen Lead benachrichtigen",
    SEND_LEAD_SMS_SYSTEM_ACTION: "Einen Lead per SMS senden",
    NOTIFY_JOB_REMINDER_SYSTEM_ACTION: "Eine Erinnerung an eine Anfrage senden",
    CONFIRM_FEE_PAYMENT_SYSTEM_ACTION: "Eine Gebührenzahlung bestätigen",
    FAIL_FEE_PAYMENT_SYSTEM_ACTION: "Eine fehlgeschlagene Gebührenzahlung erfassen",
    ACTIVATE_SUBSCRIPTION_SYSTEM_ACTION: "Ein Abo aktivieren",
    SUSPEND_SUBSCRIPTION_SYSTEM_ACTION: "Ein Abo aussetzen",
    RENEW_SUBSCRIPTION_SYSTEM_ACTION: "Ein Abo verlängern",
    EXPIRE_SUBSCRIPTION_SYSTEM_ACTION: "Ein abgelaufenes Abo beenden",
    REMIND_SUBSCRIPTION_EXPIRY_SYSTEM_ACTION: "Einen Profi erinnern, dass sein Tarif endet",
    EXPIRE_SETTING_VALUE_SYSTEM_ACTION: "Einen Einstellungswert verfallen lassen",
    DELETE_ID_IMAGES_SYSTEM_ACTION: "Ausweisbilder löschen",
    FLAG_BANNED_DOCUMENT_SYSTEM_ACTION: "Ein verbotenes Dokument markieren",
    SUSPEND_ON_CRITICAL_REPORT_SYSTEM_ACTION: "Bei einer kritischen Meldung sperren",
  },
  /** The settings someone chooses for themselves, read as words, not ids (#185). */
  settings: {
    THEME_USER_SETTING: "Design",
    COLOR_VIBE_USER_SETTING: "Farbe",
    LANGUAGE_USER_SETTING: "Sprache",
    LOW_DATA_MODE_USER_SETTING: "Datensparmodus",
    NEW_LEAD_NOTIFICATION_USER_SETTING: "Mich über neue Leads benachrichtigen",
    QUOTE_RECEIVED_NOTIFICATION_USER_SETTING: "Mich benachrichtigen, wenn ein Angebot eintrifft",
    NEW_LEAD_SMS_USER_SETTING: "Neue Leads per SMS senden",
    QUOTE_RECEIVED_SMS_USER_SETTING: "Ein Angebot per SMS senden",
    LEAD_TRADES_USER_SETTING: "Berufe, für die ich Leads möchte",
    LEAD_SERVICE_AREA_USER_SETTING: "Wo ich arbeite",
    LEAD_RADIUS_USER_SETTING: "Wie weit ich fahre",
    LEAD_DAYS_USER_SETTING: "Tage, an denen ich Arbeit annehme",
    URGENT_JOBS_USER_SETTING: "Dringende Anfragen",
    CONSOLE_THEME_STAFF_SETTING: "Konsolen-Design",
    CONSOLE_LANGUAGE_STAFF_SETTING: "Konsolen-Sprache",
  },
  /** The grid's section titles. */
  categories: {
    appearance: "Darstellung",
    notifications: "Benachrichtigungen",
    leads: "Leads",
    discovery: "Suche",
    jobs: "Anfragen",
    profile: "Profil",
    accounts: "Konten",
    support: "Fälle",
    onBehalf: "Im Namen eines Kunden",
    onboarding: "Prüfung",
    payments: "Zahlungen",
    safety: "Vertrauen & Sicherheit",
    messaging: "Nachrichten",
    configuration: "Konfiguration",
    staff: "Team & Zugriff",
    audit: "Audit",
  },
};
